import { useContext } from 'react';
import { AuthContext } from './authContext';

/** Returns the auth context or null when called outside an AuthProvider. */
export const useOptionalAuth = () => useContext(AuthContext);
